const Filter = ({ width = 28, height = 28, color = 'currentColor', ...props }) => {
  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill="none"
      color={color}
      {...props}
    >
      <path
        d="M24.5 4.6665V6.99984H23.3333L17.5 15.7498V25.6665H10.5V15.7498L4.66667 6.99984H3.5V4.6665H24.5ZM7.47133 6.99984L12.8333 15.0428V23.3332H15.1667V15.0428L20.5287 6.99984H7.47133Z"
        fill={color}
      />
    </svg>
  )
}

export default Filter
